/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Ocop_LogoInputs */

const vi_shop_home_ocop_logo = /** @type {(inputs: Shop_Home_Ocop_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo OCOP`)
};

/**

* @param {Shop_Home_Ocop_LogoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_ocop_logo = /** @type {((inputs?: Shop_Home_Ocop_LogoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Ocop_LogoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_ocop_logo(inputs)
});